import { Currency } from '../models/enums/currency';

export class CurrencyUtil {
    
    static formatCurrency(value: number, currency: Currency = Currency.BRL, maxFractionDigits: number = 2): string {
        if (value === null || value === undefined) {
            return '';
        }

        const safeCurrency = currency || Currency.BRL;

        const locale = this.getCurrencyLocale(safeCurrency);
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: safeCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: maxFractionDigits
        });

        return formatter.format(value);
    }

    private static getCurrencyLocale(currency: Currency): string {
        
        const safeCurrency = currency || Currency.BRL;
        
        switch (safeCurrency) {
            case Currency.BRL:
                return 'pt-BR';
            case Currency.USD:
                return 'en-US';
            case Currency.EUR:
                return 'de-DE';
            default:
                return 'pt-BR';
        }
    }

    static getCurrencySymbol(currency: Currency): string {
        
        const safeCurrency = currency || Currency.BRL;
        
        switch (safeCurrency) {
            case Currency.BRL:
                return 'R$';
            case Currency.USD:
                return '$';
            case Currency.EUR:
                return '€';
            default:
                return 'R$';
        }
    }

} 